export default __webpack_public_path__ + "static/media/isChecked.70f48026.svg";